
















import { Vue, Prop, Component } from "vue-property-decorator";
import { objectAssign } from "@/fit-ui/common/util";

@Component({
  name: "FitForm"
})
export default class FitForm extends Vue {
  @Prop() public title!: string;
  @Prop() public desc!: string;
  @Prop() public htmlDesc!: string;
  @Prop({ default: false }) public hideHeader!: boolean;
  @Prop() public model!: object;
  @Prop() public rules!: object;
  @Prop({ default: false }) public autowidth!: boolean;
  public fields: any[] = [];
  public validate(callback) {
    if (!this.model) {
      console.warn("[Form]model is required for validate to work!");
      return;
    }

    let promise;
    // if no callback, return promise
    if (typeof callback !== "function") {
      promise = new Promise((resolve, reject) => {
        callback = function(valid) {
          valid ? resolve(valid) : reject(valid);
        };
      });
    }

    let valid = true;
    let count = 0;
    // 如果需要验证的fields为空，调用验证时立刻返回callback
    if (this.fields.length === 0 && callback) {
      callback(true);
    }
    let invalidFields = {};
    this.fields.forEach(field => {
      if (!field.prop) {
        count++;
        return;
      }
      // @ts-ignore
      field.validate("", (message, field) => {
        if (message) {
          valid = false;
        }
        invalidFields = objectAssign({}, invalidFields, field);
        if (typeof callback === "function" && ++count === this.fields.length) {
          callback(valid, invalidFields);
        }
      });
    });

    if (promise) {
      return promise;
    }
  }
  public mounted() {
    if (!this.autowidth) {
      return;
    }
      let maxLabelWidth = 0;
      const length = this.fields.length;
      this.fields.forEach((field, index) => {
        const labelWidth = field.getLabelWidth() + 1;
        if (labelWidth > maxLabelWidth) {
          maxLabelWidth = labelWidth;
        }
        if (index === length - 1) {
          // 最后一个
          this.notifyWidthChange(maxLabelWidth);
        }
      });
    
  }
  public notifyWidthChange(width: number) {
    this.fields.forEach((field, index) => {
      field.setLabelWidth(width);
    });
  }
  public created() {
    this.$on("form.addField", field => {
      if (field) {
        this.fields.push(field);
      }
    });
    /* istanbul ignore next */
    this.$on("form.removeField", field => {
      if (field.prop) {
        this.fields.splice(this.fields.indexOf(field), 1);
      }
    });
  }
}
